import React from 'react';
import { useDispatch } from 'react-redux';
import { Button } from 'reactstrap';
import { actions } from '../../context';

function UnMutePracticeForm({practiceId, currentPracticeId}) {
    
    const dispatch = useDispatch();
    
    const unmute = () => {
        if(!practiceId) return;
        dispatch(actions.practice.unmutePractice(practiceId))
            .then(() => {
                dispatch(actions.toggle.triggerRefresh());
                if (practiceId === currentPracticeId)
                    dispatch(actions.toggle.triggerPracticeRefresh());
            })
            .then(() =>
                dispatch(actions.toggle.toggleMutePracticeModal(false))
            );
    };

    return (
        <div className="d-flex justify-content-center">
            <Button className="m-3" color="primary" onClick={() => unmute()}>
                Yes
            </Button>
            {/* TODO: make it so that the mute modal is the empty shell that takes in the two isolated forms? */}
            <Button
                className="m-3"
                color="danger"
                onClick={() =>
                    dispatch(actions.toggle.toggleMutePracticeModal(false))
                }>
                Cancel
            </Button>
        </div>
    );
}

export default UnMutePracticeForm;
